module.exports = __webpack_public_path__ + "img/awards_chip4.ad42178b.png";